// Hotwire（Turbo）を起動。ページ遷移の高速化と Turbo Frames / Streams を有効化する
import "@hotwired/turbo-rails"

// Stimulus を起動し、app/javascript/controllers 配下のコントローラを自動登録する
import { Application } from "@hotwired/stimulus"

const application = Application.start()

// *_controller.{js,ts,tsx} を Vite の glob で読み込み、ファイル名から識別子を決めて登録する
// 例: property_map_controller.ts → data-controller="property-map"
const controllers = import.meta.glob("../controllers/*_controller.{js,ts,tsx}", { eager: true })
for (const path in controllers) {
  const identifier = path
    .split("/")
    .pop()
    .replace(/_controller\.(js|ts|tsx)$/, "")
    .replace(/_/g, "-")
  application.register(identifier, controllers[path].default)
}
